module.exports = __webpack_public_path__ + "img/05.fd1174a9.jpg";